export default "__VITE_ASSET__DhUSSTW8__"